module.exports = __webpack_public_path__ + "static/media/active-microphone.f7eba284.svg";